// Edit Item Matrix charges have one quantity rule regardless of older UI flags.
// Fixed charges always represent one charge; Run charges retain an edited run quantity.
const chargeKind = (row = {}) => {
  // Ignore generic values (Cost/Breakdown) and continue to the next hint.
  // An explicit SubType from the Matrix wins over stale presentation flags.
  const hints = [row.subType, row.SubType, row.priceType,
    row.chargeType, row.ChargeType, row.type];
  for (const hint of hints) {
    const value = String(hint ?? "").trim().toLowerCase();
    if (value === "fixed" || value === "fixed charge") return "Fixed";
    if (value === "run" || value === "run charge") return "Run";
  }
  return row.isRunCharge === true ? "Run" : null;
};

const isFixedChargeRow = (row = {}) => chargeKind(row) === "Fixed";
const savedDecorationQuantity = (row = {}) =>
  isFixedChargeRow(row) ? 1 : Number(row.quantity ?? row.Quantity ?? 0) || 0;

const applyMatrixChargeType = (row = {}, matrixChargeType, defaultRunQuantity = 1) => {
  if (matrixChargeType !== "Fixed" && matrixChargeType !== "Run") return row;
  const wasFixed = isFixedChargeRow(row);
  const fixed = matrixChargeType === "Fixed";
  const normalized = fixed ? "Fixed Charge" : "Run Charge";
  const existingQuantity = Number(row.quantity ?? row.Quantity);
  const defaultQuantity = Number(defaultRunQuantity) > 0 ? Number(defaultRunQuantity) : 1;
  const quantity = fixed ? 1
    : wasFixed || !Number.isFinite(existingQuantity) || existingQuantity <= 0
      ? defaultQuantity
      : row.quantity ?? row.Quantity;

  return {
    ...row,
    type: fixed ? "Fixed Charge" : "breakdown",
    subType: normalized,
    SubType: normalized,
    priceType: normalized,
    chargeType: matrixChargeType,
    ChargeType: matrixChargeType,
    isRunCharge: !fixed,
    quantity,
  };
};

module.exports = { chargeKind, isFixedChargeRow, savedDecorationQuantity, applyMatrixChargeType };
